import React from 'react';
import { Flex, Row, Pagination, Empty, Tag, Radio, Input, Modal, Form, Switch } from 'antd';
import { FormOutlined, BellOutlined, SearchOutlined } from '@ant-design/icons';
import NavItem from '../../components/nav-item';
import SwitchShop from '../shop/switch-shop';
import OrderCard from './card';
import { getCurrentShopId } from '../shop/get-current-shop';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const [orderList, setOrderList] = React.useState([]);
    const [total, setTotal] = React.useState(0);
    const [shopId, setShopId] = React.useState(null);
    const [searchForm] = Form.useForm();
    const url = new URL(window.location);
    const [page, setPage] = React.useState(url.searchParams.get('page') || 1);

    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);

    React.useEffect(() => {
        if (shopId) {
            loadOrderList();
        }
    }, [shopId]);

    const getOrderList = async () => {
        const response = await fetch(`/api/order/list?shopId=${shopId}&${url.searchParams.toString()}`);
        return await response.json();
    }

    const loadOrderList = async (page = 1) => {
        url.searchParams.set('page', page);
        setPage(page);
        const res = await getOrderList(page);
        setOrderList(res?.data?.rows || []);
        setTotal(res?.data?.count || 0);
    }

    const onSearch = async () => {
        const content = <Form form={searchForm}>
            <Form.Item name='searchType' style={{marginBottom: '10px'}}>
                <Radio.Group defaultValue='address' size="middle" optionType='button'>
                    <Radio value="address">地址</Radio>
                    <Radio value="phoneNo">电话</Radio>
                    <Radio value="orderNo">订单号</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item name='keyword'>
                <Input />
            </Form.Item>
        </Form>

        Modal.confirm({
            title: '搜索订单',
            icon: null,
            content,
            okText: '确定',
            cancelText: '取消',
            onOk: async () => {
                const {keyword, searchType = 'address'} = searchForm.getFieldsValue();
                console.log(keyword, searchType);
                if(keyword && searchType) {
                    url.searchParams.set(searchType, keyword.trim());
                    url.searchParams.set('page', 1);
                    window.history.pushState({}, "", url);

                    loadOrderList();
                }
            }
        })
        // let list = await getOrderList();
        // setList(list);
    }

    const onKeywordRemove = async (key, value) => {
        console.log(key, value);
        url.searchParams.delete(key);
        url.searchParams.set('page', 1);
        window.history.pushState({}, "", url);

        loadOrderList();
    }

    const onPayStatusChange = async (checked) => {
        if(checked) {
            url.searchParams.set('payStatus', 1);
        } else {
            url.searchParams.delete('payStatus');
        }
        url.searchParams.set('page', 1);
        window.history.pushState({}, "", url);

        loadOrderList();
    }
    
    return (
        <div>
            <SwitchShop />
            <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                <NavItem href="/order/create" text="创建订单">
                    <FormOutlined style={iconStyle} />
                </NavItem>

                <NavItem href="/order/notify-setting" text="通知设置">
                    <BellOutlined style={iconStyle} />
                </NavItem>

                {/* <NavItem href="/goods/proxy" text="优惠券">
                    <TransactionOutlined style={iconStyle} />
                </NavItem> */}

            </Row>
            <Flex gap={15}>
                <h2>订单列表</h2>
                <SearchOutlined onClick={onSearch} style={{fontSize: 22, color: 'rgb(22, 119, 255)'}} />
            </Flex>
            <div style={{ marginBottom: 10 }}>
                {
                    Array.from(url.searchParams).filter(([key]) => ['orderNo', 'phoneNo', 'address'].includes(key)).map(([key, value]) => {
                        return <Tag key={key} color="green" style={{margin: '0 5px 0 0'}} closable onClose={() => onKeywordRemove(key, value)}>
                            {'..' + value.slice(-2)}
                        </Tag>
                    })
                }
            </div>
            <Flex style={{ margin: '0 0 10px 0'}}>
                <Pagination current={page} showSizeChanger={false} simple={{ readOnly: true }} defaultCurrent={1} total={total} 
                    onChange={(page) => loadOrderList(page)} 
                />
                
                <Flex align='center'><Switch onChange={onPayStatusChange} defaultChecked={+(url.searchParams.get('payStatus')) === 1} /><span>未完付</span></Flex>
            </Flex>
            <Flex gap={10} wrap align='flex-start'>
                {
                    orderList.map((item, index) => {
                        return <OrderCard onFlowChange={loadOrderList} content={item} key={index} style={{minWidth: 360, marginBottom: 10, maxWidth: 456, width: '100%'}} />
                    })
                }
                {
                    orderList.length === 0 && (
                        <Empty style={{width: '100%'}} />
                    )                
                }
            </Flex>
            <Pagination current={page} showSizeChanger={false} simple={{ readOnly: true }} defaultCurrent={1} total={total} onChange={(page) => loadOrderList(page)} />
        </div>
    )
}